import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import pddlogo from '../assets/images/pddlogo.png'
import SweetAlert from 'react-bootstrap-sweetalert';
import Swal from 'sweetalert2'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    NavLink, useHistory
} from "react-router-dom";
import { GetCustomerName, ISValidateNationalNumber } from './ReservationWebApi';

export const ReservationSet = () => {
    const history = useHistory();
    const { ID, BeneficiaryCode, BeneficiaryName, FromPartTime, ToPartTime } = useParams();
    const [getID, setGetID] = useState();
    const [isSuccess, setISSuccess] = useState(false);
    const [isRegister, setIsRegister] = useState(false);
    const [ISInquiry, setISInquiry] = useState(false);
    const [ISApplyInquiry, setISApplyInquiry] = useState(false);
    const [dataByNationalNumber, setdataByNationalNumber] = useState();
    const [customerName, setCustomerName] = useState('');


    const NationalNumber = useRef('');
    const FirstName = useRef('');
    const LastName = useRef('');
    const FatherName = useRef('');
    const MobileNumber = useRef('');


    useEffect(async () => {

        const result = await GetCustomerName()

        if (result.length = 1) {
            setCustomerName(result[0].ConfigValue);
        }
    }, [])
    useEffect(() => {
        if (getID != null) {
            if ((getID.length == 1)) {
                const firstrow = getID[0];

                if (firstrow.ID > 0) {
                    Swal.fire('عمليات با موفقيت انجام شد', ' نوبت شما با شماره پيگيري ' + firstrow.ID + ' ثبت گرديد', 'success').then((result) => { history.push('/'); });
                }
                else {
                    Swal.fire('خطايي رخ داده است', firstrow.ErrorDescription, 'error').then((result) => { });

                }
            }
            if ((getID.length == 0)) {
                Swal.fire('خطايي رخ داده است', ' پاسخي از سمت سرور دريافت نشده لطفا مجددا سعي نمائيد', 'error').then((result) => { })
            }

        }
    }, [getID])
    useEffect(() => {
        console.log('useEffect 2');
        console.log(ISInquiry);
        console.log(dataByNationalNumber);
        if (dataByNationalNumber != null) {
            setISInquiry(false);
            console.log('Last Data');
            console.log(dataByNationalNumber);
            if (dataByNationalNumber.length == 1) {
                const firstrow = dataByNationalNumber[0];
                FirstName.current.value = firstrow.FirstName;
                LastName.current.value = firstrow.LastName;
                FatherName.current.value = firstrow.FatherName;
                MobileNumber.current.value = firstrow.MobileNumber;
            }
            else {
                Swal.fire('خطا', 'اطلاعاتي يافت نشد', 'error').then(() => { return })
                FirstName.current.value = '';
                LastName.current.value = '';
                FatherName.current.value = '';
                MobileNumber.current.value = '';
            }
        }
    }, [dataByNationalNumber])


    async function ReservationInquiry() {
        if (NationalNumber.current.value.length != 10) {
            Swal.fire('خطا', 'كد ملي حتما بايد 10 رقم باشد', 'error').then(() => { return })
            return
        }
        setISApplyInquiry(true);
        try {

            const apiUrl = window.BASE_URL + '/api/pdd/ReservationByNationalNumber?NationalNumber=' + NationalNumber.current.value
            fetch(apiUrl)
                .then(response => response.json())
                .then((data) => {
                    setdataByNationalNumber(data);
                },
                    (error) => {
                        alert('error in registration');
                    })
        }
        catch (error) {
            Swal.fire('خطا', error, 'error').then(() => { return })
        }
        setISApplyInquiry(false);
    }
    async function ReservationRegister() {

        var CanRegister = true;
        if (NationalNumber.current.value.length != 10) {
            CanRegister = false;
            Swal.fire('خطا', 'كد ملي حتما بايد 10 رقم باشد', 'error').then(() => { return })
        }

        const ISValidateNN = await ISValidateNationalNumber(NationalNumber.current.value);
        console.log(ISValidateNN);
        if (ISValidateNN == "0") {
            CanRegister = false;
            Swal.fire('خطا', 'كد ملي با قوانين ثبت احوال همخواني ندارد', 'error').then(() => { return })

        }

        if (FirstName.current.value.length == 0) {
            CanRegister = false;
            Swal.fire('خطا', 'نام بيمار را وارد نمائيد', 'error').then(() => { return })
        }
        if (LastName.current.value.length == 0) {
            CanRegister = false;
            Swal.fire('خطا', 'نام خانوادگي را وارد نمائيد', 'error').then(() => { return })
        }
        if (FatherName.current.value.length == 0) {
            CanRegister = false;
            Swal.fire('خطا', 'نام پدر را وارد نمائيد', 'error').then(() => { return })
        }

        if (MobileNumber.current.value.length != 11) {
            CanRegister = false;
            Swal.fire('خطا', 'شماره موبايل حتما بايد 11 رقم باشد', 'error').then(() => { return })
        }

        if (CanRegister) {
            const apiUrl = window.BASE_URL + '/api/pdd/ReservationSet?ID=' + ID + '&NationalNumber=' + NationalNumber.current.value + '&FirstName=' + FirstName.current.value + '&LastName=' + LastName.current.value + '&FatherName=' + FatherName.current.value + '&MobileNumber=' + MobileNumber.current.value
            fetch(apiUrl)
                .then(response => response.json())
                .then((data) => {
                    setGetID(data);
                    setISSuccess(true);
                    setIsRegister(true);
                },
                    (error) => {
                        alert('error in registration');
                    })
            const PDDApiUrl = 'http://www.pdd.ir/pddwebapi/api/pdd/ReservationSetPDD?ID=' + ID + '&NationalNumber=' + NationalNumber.current.value + '&FirstName=' + FirstName.current.value + '&LastName=' + LastName.current.value + '&FatherName=' + FatherName.current.value + '&MobileNumber=' + MobileNumber.current.value + '&CustomerName=' + customerName
            console.log(PDDApiUrl);
            const response = fetch(PDDApiUrl)

        }
    }



    return (
        <>
            <Helmet>
                <title>ثبت نام جهت نوبت {BeneficiaryName} در تاريخ {localStorage.getItem('SelectBeneficiaryDate')} زمان {FromPartTime} {ToPartTime}</title>
            </Helmet>
            <div>
                {/* Navigation */}
                <div className="nav bg-primary fixed-top pt-2 pb-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-1 pl-0 pr-0" >
                                <img src={pddlogo} alt="" ></img>
                            </div>
                            <div className="col-6 pl-0 pr-0 pt-2">
                                <NavLink to="/" className="header-font mt-0 mb-0 ml-0 mr-1 pl-0 pr-0 text-white d-flex justify-content-start" >نوبت دهي طب پرداز ({process.env.REACT_APP_VERSION})</NavLink>
                            </div>
                            <div className="col-5 pl-0 pr-0 pt-2">
                                <NavLink to="/" className="header-font mt-0 mb-0 ml-4 mr-3 pl-0 pr-0 text-white  d-flex justify-content-end" >{customerName}</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Page Content */}
                <div className="container">
                    {/* Jumbotron Header */}
                    <header className="bg-info my-4 pt-5 pb-1">
                        <h3 className="display-12">نوبت دهي دكتر {BeneficiaryName} تاريخ {localStorage.getItem('SelectBeneficiaryDate')} </h3>
                        <h3 className="display-12 text-white"> زمان از {FromPartTime} تا {ToPartTime} </h3>
                        <p className="lead">پس از ثبت مشخصات نوبت دهي شما به پايان خواهيد رسيد</p>
                        <button class="btn btn-primary" onClick={() => history.goBack()} >صفحه قبل</button>
                    </header>


                    <div className="row justify-content-center align-items-center">
                        <form className="center">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">كد ملي</label>
                                <table>
                                    <tr>
                                        <td>
                                            <input type="text" className="form-control" id="TBNationalNo" placeholder="كد ملي را وارد نمائيد" ref={NationalNumber} maxLength="10" />
                                        </td>
                                        <td>
                                            <button type="button" className="btn btn-success" onClick={() => ReservationInquiry()} disabled={ISApplyInquiry ? 'disabled' : ''}>استعلام</button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputPassword1">نام بيمار</label>
                                <input type="text" className="form-control" id="TBFirstName" ref={FirstName} maxLength="50" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputPassword1">نام خانوادگي بيمار</label>
                                <input type="text" className="form-control" id="TBLastName" ref={LastName} maxLength="50" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputPassword1">نام پدر</label>
                                <input type="text" className="form-control" id="TBFatherName" ref={FatherName} maxLength="50" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputPassword1">شماره موبايل</label>
                                <input type="text" className="form-control" id="TBMobileNumber" ref={MobileNumber} maxLength="11" />
                            </div>
                            <button type="button" className="btn btn-primary" onClick={() => ReservationRegister()}>ثبت</button>
                        </form>
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container */}
                {/* Footer */}

            </div>
            <nav className="navbar2 fixed-bottom navbar-light footer-font align-items-center align-self-center">
                <a className="mt-3 footer-font" href="http://www.pdd.ir">كليه حقوق متعلق به شركت طراح داده پيشرو مي باشد - www.pdd.ir</a>
            </nav>


        </>
    )
}
